import api from '../../../../../api/api'
import url from '../../../../../api/env'
import Utils from '../../../../../utils/Utils'

const getCategory = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api  
    .get(excludeChars ? `${url.stage.taxes}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.taxes}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${filterName}%`), {})    
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const newCategory = async data =>
  api
    .post(url.stage.taxes, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const editCategory = async (stateId, data) =>
  api
    .put(`${url.stage.taxes}/${stateId}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const removeCategory = async stateId =>
  api
    .remove(`${url.stage.taxes}/${stateId}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  getCategory,
  newCategory,
  editCategory,
  removeCategory,
}
